import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import WorkQueues from 'enums/workQueue.enum';
import { listRxIntakeRequestsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import RxInTakeRequestsTable from './RxInTakeRequestsTable';
import RxInTakeRequestsFilterButton from './RxInTakeRequestsFilterButton';
import RxInTakeRequestsFilterStatusBar from './RxInTakeRequestsFilterStatusBar';
import RxInTakeRequestsOuterFilter from './RxInTakeRequestsOuterFilter';

const RxInTakeRequests = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.rxIntakeRequests, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.RX_INTAKE_REQUESTS)) {
      dispatch(listRxIntakeRequestsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.RX_INTAKE_REQUESTS) {
    return null;
  }

  return (
    <Grid container sx={{ py: 3 }} justifyContent='space-between' alignItems='center'>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }}>
        <RxInTakeRequestsFilterStatusBar />
      </Grid>
      <Grid item>
        <Grid container gap={2}>
          <RxInTakeRequestsOuterFilter />
          <Grid item sx={{ mt: { sm: '25px', md: '25px' } }}>
            <RxInTakeRequestsFilterButton />
          </Grid>
        </Grid>
      </Grid>
      <RxInTakeRequestsTable />
    </Grid>
  );
};

export default RxInTakeRequests;
